import styled from "styled-components";

export const State = styled.div`
  height: 15px;
  width: 15px;
  border-radius: 50%;
  margin-left: 5px;
  background-color: ${({ theme }) => theme.white};
`;
